import React, { ReactElement, Component, useEffect, useContext, useState, SetStateAction, useMemo, Fragment } from "react";
import { left_menu_item, LeftMenuContext } from "../../contexts/left-menu";
import { http_get, http_request } from "../../worker/http-func";
import { Col, Row } from 'antd';
import { monitoring, monitoring_dark_blue, monitoring_black_gray } from '../../img';
import UseMenu from './monitor_menu';
import { DashboardContext, dashboard_item } from "../../contexts/monitor-lists";
// import { Redirect, withRouter } from "react-router";
import { withRouter } from "react-router";

import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { namespaces_type_item, NamespaceContext } from "../../contexts/namespaces";
import { SideFlyInContext } from '../../contexts/side-menu-fly-in';
import { item } from "../../contexts/items";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import BreadCrumbs from "../../components/breadcrumb/breadcrumb";
import { prevent } from "../applications/applications";
import { FormattedMessage } from "react-intl";
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import DropdownMenuTop from '../../components/dropdown-menu-top/dropdown-menu-top';
import { response_type } from "../../worker/function/interfaces";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { ThemeContext } from "../../contexts/theme";

const MonitorManagement: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const set_left_menu_items: React.Dispatch<SetStateAction<left_menu_item[]>> = useContext(LeftMenuContext)[1],
    // [left_menu_items, set_left_menu_items]: [left_menu_item[], React.Dispatch<SetStateAction<left_menu_item[]>>] = useContext(LeftMenuContext),
    set_workspaces: React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>> = useContext(WorkspaceContext)[1],
    [side_fly_in, set_side_fly_in]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(SideFlyInContext),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    set_dashboards: React.Dispatch<React.SetStateAction<dashboard_item[]>> = useContext(DashboardContext)[1],
    set_namespaces: React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>> = useContext(NamespaceContext)[1],
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    workspace_selected: item | undefined = useContext(WorkSpaceSelectedContext)[0],
    theme: string = useContext(ThemeContext)[0],

    // [re_direct, set_redirect]: [JSX.Element, React.Dispatch<SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [re_direct]: [JSX.Element, React.Dispatch<SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),

    path = useMemo(() => props.history.location.pathname.substring(1).substring(props.history.location.pathname.substring(1).indexOf('/') + 1), [props.history.location.pathname]);

    // 修改monitor快速切换quotas页面，内部左侧选单显示kubenetesbug
  useEffect((): void => {
    user_info.role !== '' && datacenter_name && !path.includes("service-usage") && http_get('monitor_page', ['monitor_tag_folder', set_left_menu_items, 'monitor_dbs', set_dashboards], user_info.role, user_info.subscription_id, datacenter_name, (cluster_selected || {}).name || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_left_menu_items, set_dashboards, path, set_workspaces, set_namespaces, user_info.role, path]);

  // 修改进入monitor闪现service-usage的bug
  // useEffect((): void => {
  //   if (left_menu_items?.length) {
  //     const re_direct_new: JSX.Element = (
  //       <Redirect from="/monitor" to={`/monitor/${left_menu_items[0]?.key}`} />
  //     )
  //     set_redirect(re_direct_new);
  //   } else {
  //     const re_direct_new: JSX.Element = (
  //       <Redirect from="/monitor" to={`/monitor/service-usage`} />
  //     )
  //     set_redirect(re_direct_new);
  //   }
  // }, [left_menu_items, set_redirect]);

  useEffect((): void => {
    (async () => {
      if (user_info.role !== '' && cluster_selected?.name && datacenter_name && !path.includes("service-usage")) {
        if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) || user_info.role === 'namespaceDeveloper') {
          const workspacenames: { name: string, id: string }[] = (await http_request('workspacenames', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true) as response_type).items as unknown as { name: string, id: string }[];
          workspacenames && set_workspaces(workspacenames.map(({ name, id }) => { return { metadata: { name: id, labels: { name } } } as workspaces_type_item }));
        } else {
          http_request('workspaces', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/workspaces`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected?.name || '', undefined, undefined, undefined, undefined, true);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, user_info.role, user_info.subscription_id, user_info.wkOwner_has_namespacedeveloper, set_workspaces]);

  useEffect((): void => {
    user_info.role !== '' && workspace_selected?.name && datacenter_name && !path.includes("service-usage") &&
      http_request('namespaces', props, set_namespaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name || ''}/workspace/${workspace_selected?.name}/namespaces`,
        0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected?.name || '', undefined, undefined, undefined, undefined, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, workspace_selected?.name, set_namespaces, user_info.role, user_info.subscription_id, datacenter_name, path]);

  useEffect((): void => {
    set_side_fly_in(true);
  }, [set_side_fly_in]);

  return (
    <Fragment>
      <Row className="pr-20 mt-20 pl-10">
        <div className={`${side_fly_in ? '' : 'side_fly_in'}`} onClick={prevent}>
          <Col sm={2} className="position-fixed left_second_menu">
            <Row className="header no_shadow">
              <Col sm={24} className="box_rounded inside_card_bg">
                <Row>
                  <Col sm={24} className="text-center side_menu_img">
                    <img src={theme === 'dark_blue' ? monitoring_dark_blue : theme === 'black_gray' ? monitoring_black_gray : monitoring} alt="" />
                  </Col>
                  <Col sm={24} className="card_title text-center"><FormattedMessage id="monitor" /></Col>
                </Row>
              </Col>
              <Col sm={24}><UseMenu /></Col>
            </Row>
          </Col>
        </div>
        {re_direct ? re_direct : null}
        <Col sm={side_fly_in ? 22 : 24} offset={side_fly_in ? 2 : 0} className={side_fly_in ? "side_fly" : ''}>
          <Row className="breadcrumb_sticky console">
            <Col className="pl-6" sm={1}>
              {side_fly_in ?
                <MenuUnfoldOutlined className="card_title" onClick={() => { set_side_fly_in(!side_fly_in) }} />
                :
                <MenuFoldOutlined className="card_title" onClick={() => { set_side_fly_in(!side_fly_in) }} />
              }
            </Col>
            <Col sm={22} pull={1} className="px-30">
              <BreadCrumbs />
            </Col>
          </Row>
          {
            path.includes("service-usage") ?
            <div></div> :
            <div className="mb-5"><DropdownMenuTop /></div>
          }
          {props.children}
        </Col>
      </Row>
    </Fragment>
  )
}

export default withRouter(MonitorManagement)